<template>
  <div>
    <Mainlayout></Mainlayout>
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center mt-5 m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin mt-5">
            <br />
            <br />
            <br />
 <br />
            <h4
              class="text-left mt-4 text-black bold"
              style="font-size: 24px"
            >
              Quiz Description
            </h4>

            <CCard color="light" class="p-2">
              <CCol sm="12" lg="12">
                <CRow>
                  <div class="col-3">
                    <h1
                      style="
                        font-size: revert;
                        background: #fff;
                        text-transform: uppercase;
                      "
                      class="circle-bg p-1 custom-gradient"
                    >
                      <span class="custom-gradient">{{
                        qSummary.subjectName.substring(0, 2)
                      }}</span>
                    </h1>
                  </div>
                  <div class="col-9">
                    <h4>{{ qSummary.subjectName }}</h4>
                    Grade : {{ qSummary.gradeName }}
                  </div>
                </CRow>
              </CCol>
            </CCard>
            <hr />
            <h4>Details</h4>

            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-4 text-left">Subject</div>
                <div class="col-8 text-right">
                  <strong> {{ qSummary.subjectName }}</strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-4 text-left">Grade</div>
                <div class="col-8 text-right">
                  <strong> {{ qSummary.gradeName }}</strong>
                </div>
              </CRow>
            </CCard>
            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-4 text-left">Title</div>
                <div class="col-8 text-right">
                  <strong> {{ qSummary.Title }}</strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-6 text-left">Question Amount</div>
                <div class="col-6 text-right">
                  <strong> {{ qSummary.questionCount }} Questions </strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-6 text-left">Timer</div>
                <div class="col-6 text-right">
                  <strong> {{ qSummary.TimerString }} </strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-3 text-left">Created By</div>
                <div class="col-9 text-right">
                  <strong> {{ qSummary.TeacherName }} </strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-6 text-left">Publish Date</div>
                <div class="col-6 text-right">
                  <strong>
                    {{ qSummary.CreatedDate | moment("DD/MM/YYYY HH:mm") }}
                  </strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2">
              <CRow>
                <div class="col-6 text-left">Status</div>
                <div class="col-6 text-right">
                  <label v-if="qSummary.IsPublish === false">
                    <CBadge color="warning" class="fontlist">Pending</CBadge>
                  </label>
                  <label v-else>
                    <CBadge color="success" class="fontlist">Published</CBadge>
                  </label>
                </div>
              </CRow>
            </CCard>
            <hr />

            <br />
            <div>
              <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="GoToPageQuizDraft"
                >View</CButton
              >
            </div>
            <div>
              <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="GoToDashBoard"
                >Close</CButton
              >
            </div>

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Create Quiz</h3>
        <br /><br />
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderCustom.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  // childs: [],
  // SelectedStudent: "",
  qSummary: {},
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      SubmittedForm: false,
      // childs: [],
      // SelectedStudent: "",
      qSummary: {},

      Error: false,
    };
  },
  async mounted() {
    this.GetQuizPreview();
    this.GetListChild();
    this.GetQuizDetails();
  },
  computed: {},
  methods: {
    //Get quiz summary
    async GetQuizPreview() {
      this.$API
        .get(this.$QuizPreview + "?quizId=" + this.$route.query.quizId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
            console.log(this.qSummary);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GoToPageQuizDraft() {
      this.$router.push(
        "/QuizTeacherDraft?quizId=" +
          this.$route.query.quizId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GoToPageQuizList() {
      this.$router.push(
        "/QuizTeacherQuizList?userId=" +
          this.qSummary.userId +
          "&subjectId=" +
          this.qSummary.subjectId
      );
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizTeacherDashboard?userId=" + this.$route.query.userId
      );
    },
  },
};
</script>

<style>
#fb-root{
  display:none;
}
</style>
